
export const BACKGROUND_COLOR = "#FFFFFF"
export const TEXT_COLOR = "#000000"
export const SELECTED_COLOR = "#4c8bf5"